export class UserModel {
  image: string;
  name: string;
  bio: string;
  link: string;
  provider: string;
  uid: string;
  created_datetime: any;
  count_events_created: Number;
  count_events_participate: Number;

  constructor(){
    this.uid = "";
    this.image = "";
    this.name = "";
    this.bio = "";
    this.link = "";
    this.provider = "";
    this.created_datetime = new Date();
    this.count_events_created = 0;
    this.count_events_participate = 0;
  }

  getData(): object {
      const result = {};
      Object.keys(this).map(key => result[key] = this[key]);
      return result;
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.model.ts